import Loadable from 'react-loadable';

const SendSampleDigestEmailAction = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "SendSampleDigestEmailAction" */ './SendSampleDigestEmailAction'),
  loading: () => null,
});

export default SendSampleDigestEmailAction;
